import script from "./NewDividendForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewDividendForm.vue?vue&type=script&setup=true&lang=ts"

import "./NewDividendForm.vue?vue&type=style&index=0&id=49f51691&lang=postcss"

const __exports__ = script;

export default __exports__